import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material"
import ButtonElement from "../button/ButtonElement"

type PopupElementProps = {
    open: boolean,
    onClose: () => void,
    title: string,
    content?: any,
    goNextLabel?: string,
    ignoreLabel?: string,
    goNext?: () => void,
    ignore?: () => void
}

const PopupElement = ({ open, onClose, title, content, goNextLabel, ignoreLabel, goNext, ignore }: PopupElementProps) => {
    return <Dialog
    open={open}
    onClose={onClose}
    aria-labelledby="popup-dialog-title"
    aria-describedby="popup-dialog-description"
  >
    <DialogTitle textAlign='center' id="popup-dialog-title">
      {title}
    </DialogTitle>
    {!!content && <DialogContent sx={{ padding: '0 20px' }}>
      <DialogContentText id="popup-dialog-description">
        {content}
      </DialogContentText>
    </DialogContent>}
    <DialogActions sx={{ padding: '20px' }}>
      {!!ignore && <ButtonElement onClick={ignore} sx={{ flex: 1, background: '#FFFFFF66' }}>{ignoreLabel}</ButtonElement>}
      {!!goNext && <ButtonElement onClick={goNext} sx={{ flex: 1 }}>{goNextLabel}</ButtonElement>}
    </DialogActions>
  </Dialog>
}

export default PopupElement